import {
  PageModuleDataWithPageId,
  PageModuleStatus,
} from "entities/pages/types";
import { FC } from "react";
import SpaceBetweenCenter from "shared/components/Layout/components/SpaceBetweenCenter";
import ModuleTileHeader from "shared/components/ModuleTileHeader";
import { ContentWrapper } from "../../styled";
import Skeleton from "./components/Skeleton";

interface TopWinnersProps {
  isLoading: boolean;
  data: PageModuleDataWithPageId;
  onEditComponent: (data: PageModuleDataWithPageId) => void;
  onDeleteComponent: (data: PageModuleDataWithPageId) => void;
  onUpdateStatus: (params: {
    moduleId: string;
    status: PageModuleStatus;
  }) => void;
}

const TopWinners: FC<TopWinnersProps> = ({
  isLoading,
  data,
  onEditComponent,
  onDeleteComponent,
  onUpdateStatus,
}) => {
  return (
    <ContentWrapper>
      {isLoading && (
        <SpaceBetweenCenter>
          <Skeleton />
        </SpaceBetweenCenter>
      )}
      {!isLoading && (
        <ModuleTileHeader
          module={data}
          onEditComponent={onEditComponent}
          onDeleteComponent={onDeleteComponent}
          onUpdateStatus={onUpdateStatus}
        />
      )}
    </ContentWrapper>
  );
};

export default TopWinners;
